
import { Input } from "@/components/ui/input";
import { ButtonColorful } from "@/components/ui/button-colorful";

interface ClientsHeaderProps {
  clientCount: number;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onAddClient: () => void;
  showAddButton: boolean;
  isBetaTier?: boolean;
  isFounder?: boolean;
}

export function ClientsHeader({
  clientCount,
  searchQuery,
  onSearchChange,
  onAddClient,
  showAddButton,
  isBetaTier,
  isFounder
}: ClientsHeaderProps) {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center space-y-4 md:space-y-0">
      <div className="space-y-1">
        <h2 className="text-2xl font-bold text-white">Your Clients</h2>
        <p className="text-gray-300">
          {clientCount} {clientCount === 1 ? "client" : "clients"} total
          {isBetaTier && !isFounder && " • Beta tier (max 5 clients)"}
          {isFounder && " • Founder tier (unlimited access)"}
        </p>
      </div>
      <div className="flex w-full md:w-auto space-x-3 items-center">
        <Input
          className="max-w-md bg-black/20 border-black/20 text-white placeholder:text-white/60 focus:border-white/40 focus:ring-white/10"
          placeholder="Search clients..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
        {showAddButton && (
          <ButtonColorful
            onClick={onAddClient}
            label="Add Client"
            iconPosition="left"
            icon="plus"
            className="flex-shrink-0"
          />
        )}
      </div>
    </div>
  );
}
